import converters_module from '@converters/admin/store.js'

window.config = require('@config/config.js');
const CONFIG = new config();

const store = {
    namespaced: true,
    state: {
        routes: {},
    },
    getters: {
    },
    actions: {
    },
    mutations: {
    },
    modules: {
        converters_module,
    }
}

export default store
